export const NON_ALPHANUMERIC_REGEX = RegExp('[^a-zA-Z0-9]', 'g');